/**
 * アコーディオンの動作
 * 検索ボックス / SPメニュー
 */

export default class Filter {
  constructor(selector) {
    this.selector = selector;
    this.el = document.querySelector(selector);
    this.detailsEl = null;
    this.conntainerEl = null;
    this.contentEl = null;
    this.isOpen = false;

    if (!this.el) return;

    this.bind = this.bind.bind(this);
    this.bindCheckboxListeners = this.bindCheckboxListeners.bind(this);
    this.handleClick = this.handleClick.bind(this);

    this.initialize();
  }

  initialize() {
    this.detailsEl = this.el.querySelector('details');
    this.conntainerEl = this.el.querySelector('.js-filter-container');
    this.contentEl = this.el.querySelector('.js-filter-content');

    if (this.contentEl) {
      this.conntainerEl.style.height = 0;
    }

    this.bind();
    this.bindCheckboxListeners();
  }

  bind() {
    this.el.addEventListener('click', this.handleClick);
  }


  // カテゴリがチェックされた時に高さを更新
  bindCheckboxListeners() {
    const checkboxes = this.el.querySelectorAll('.c-category__input');
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        // details が開いているときのみ更新
        if (this.isOpen) {
          this.updateHeight();
        }
      });
    });
  }

  handleClick(e) {
    if (!e.target.closest('summary')) {
      return;
    }
    e.preventDefault();
    this.isOpen ? this.close() : this.open();
  }


  updateHeight() {
    const newHeight = this.categoriesEl ? this.categoriesEl.clientHeight : this.contentEl.clientHeight;
    // 一時的にtransitionを無効化
    const originalTransition = this.conntainerEl.style.transition;
    this.conntainerEl.style.transition = 'none';
    // 高さを更新
    this.conntainerEl.style.height = `${newHeight}px`;
    // レイアウトを再計算 もとのアニメーションを復活
    void this.conntainerEl.offsetWidth;
    this.conntainerEl.style.transition = originalTransition;
  }

  open() {
    this.detailsEl.setAttribute('open', '');

    const height = this.contentEl.clientHeight;
    this.conntainerEl.addEventListener(
      'transitionend',
      () => {
        this.detailsEl.setAttribute('open', '');
        this.isOpen = true;
      },
      { once: true },
    );
    this.conntainerEl.style.height = `${height}px`;
  }

  close() {
    this.conntainerEl.addEventListener(
      'transitionend',
      () => {
        this.detailsEl.removeAttribute('open');
        this.isOpen = false;
      },
      { once: true },
    );
    this.conntainerEl.style.height = 0;
  }
}
